import { useSelectableStudents } from 'layout/MainLayout/components/Sidebar/components/components/StudentSection/hooks/useSelectableStudents';
import { useUserRole } from 'shared/hooks/user';
import { UserRole } from 'shared/types';

export const useReadOnly = () => {
  const userRole = useUserRole();
  const selectableStudents = useSelectableStudents();

  return (
    userRole === UserRole.Student ||
    userRole === UserRole.Staff ||
    userRole === UserRole.Admin ||
    (userRole === UserRole.Parent && !selectableStudents.length)
  );
};
